export default "__VITE_ASSET__hUzxMjO2ZTgrpKWsKsXtzQ__"